import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_fff6f6 = setTheme(({ theme }) => `background-color: ${theme.colors.color_fff6f6}`);
